export * as addRecordResponsiblePersons from './add-record-responsible-persons'
export * as removeRecordResponsiblePerson from './remove-record-responsible-person'
export * as updateRecordResponsiblePerson from './update-record-responsible-person'
